<h2 mat-dialog-title>Zones Explained</h2>
<app-zone-explanation [inPopup]="true"></app-zone-explanation>